(function () {
  if (window.__shopPageInitialized) return;
  window.__shopPageInitialized = true;

  function initDragScroll(root) {
    var dragScrollEls = (root || document).querySelectorAll("[data-drag-scroll]");

    dragScrollEls.forEach(function (slider) {
      if (slider.dataset.dragScrollReady === "true") return;
      slider.dataset.dragScrollReady = "true";

      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var hasDragged = false;
      var suppressClick = false;

      function onMouseMove(e) {
        if (!isDown) return;

        var distance = e.pageX - startX;

        if (Math.abs(distance) > 5) {
          hasDragged = true;
          suppressClick = true;
          slider.classList.add("is-dragging");

          // Only prevent default after we know it is a drag
          e.preventDefault();

          slider.scrollLeft = scrollLeft - distance;
        }
      }

      function onMouseUp() {
        if (!isDown) return;

        isDown = false;
        slider.classList.remove("is-dragging");

        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);

        // Keep suppressClick alive just long enough for the click event after mouseup
        setTimeout(function () {
          hasDragged = false;
          suppressClick = false;
        }, 150);
      }

      slider.addEventListener("mousedown", function (e) {
        if (e.button !== 0) return;

        isDown = true;
        hasDragged = false;
        suppressClick = false;

        startX = e.pageX;
        scrollLeft = slider.scrollLeft;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      });

      slider.addEventListener(
        "click",
        function (e) {
          if (!suppressClick && !hasDragged) return;

          e.preventDefault();
          e.stopPropagation();

          hasDragged = false;
          suppressClick = false;
        },
        true
      );

      // Prevent browser's native image/link drag ghost, but does not block normal clicks
      slider.addEventListener("dragstart", function (e) {
        e.preventDefault();
      });
    });
  }

  function addToCart(button) {
    var variantId = button.getAttribute("data-variant-id");
    if (!variantId || button.disabled) return;

    button.disabled = true;
    button.classList.add("is-loading");

    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then(function () {
        if (
          window.liquidAjaxCart &&
          typeof window.liquidAjaxCart.update === "function"
        ) {
          window.liquidAjaxCart.update();
        }

        document.body.classList.add("js-show-ajax-cart");
      })
      .catch(function (error) {
        console.error("Shop page add to cart failed", error);
        alert("Sorry, something went wrong adding this to your cart.");
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove("is-loading");
      });
  }

  function initShopPage() {
    initDragScroll(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShopPage);
  } else {
    initShopPage();
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-shop-page-add-to-cart]");
    if (!button) return;

    event.preventDefault();
    addToCart(button);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initDragScroll(event.target);
  });
})();